// extracted by mini-css-extract-plugin
module.exports = {"header":"AcceptWebInviteView_header__iQWzC","description":"AcceptWebInviteView_description__QIYrC","link":"AcceptWebInviteView_link__PGv6l"};